import React, { useContext, useState } from 'react';

import InputMask from 'react-input-mask';

import { UserContext } from '../../context/UserContext';
import { validateRegExpPattern } from '../../helpers/validation';

export default function BnplSignIn({ className, onSubmitInternal }) {
  const { loading } = useContext(UserContext);
  const [phoneNumber, setPhoneNumber] = useState('1');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // /^\+1-[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
  let pattern = /^\+1-[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
  //  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const validateInputField = (value) => {
    if (!value) {
      setError('This field should not be empty.');
      return false;
    } else if (!validateRegExpPattern(value, pattern)) {
      setError('Format is incorrect.');
      return false;
    } else {
      setError('');
      return true;
    }
  };

  const handleChangePhoneNumber = (e) => {
    validateInputField(e.target.value);
    setPhoneNumber(e.target.value);
  };

  const handleContinue = async () => {
    const result = validateInputField(phoneNumber);

    if (result) {
      await onSubmitInternal({
        email: phoneNumber.replace('+', '').replaceAll('-', ''),
        password: ' ',
      });
    }
  };

  return (
    <div className={className}>
      <div className={`${className}__title`}>
        <h1>Welcome Back</h1>
        <p>Sign in to your account with your phone number.</p>
      </div>
      <div className={`${className}__content`}>
        <div className="form-field">
          <label htmlFor="phone-number-input">Phone Number</label>
          <InputMask
            id="phone-number-input"
            name="phone-number-input"
            mask="+9-999-999-9999"
            value={phoneNumber}
            onChange={(e) => handleChangePhoneNumber(e)}
            placeholder="Enter your phone number"
            spellCheck={false}
          />
        </div>
        {error && <p className="error-text">{error}</p>}
      </div>
      <div className={`${className}__button-container margin-top-0`}>
        <button type="submit" disabled={loading} onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}
